export default __webpack_public_path__ + "static/media/VKOW_11_mos_MPUR.72a48c79.wav";